/**
 * @file 质押确认弹窗
 */
import { useEffect } from 'react';
import { Modal, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { CoinInfo } from '@/types/common';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { Row, GasCircleRow, SlippageLostRow } from '@/components';
import { GasStore } from '@/types/stake';
import { StakingContent } from '../stakingContent';
import { formatUSDYield } from '@/utils/num';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  currentStakeToken: CoinInfo;
  stakeAmount: string;
  slippage: string;
  aprPerDay: string;
  stakeLpInfo: Partial<CoinInfo>;
  buttonIsLoading: boolean;
  confirmButtonText: string;
  gasStore: GasStore;
  onClose: () => void;
  beginStake: () => Promise<void>;
}

export const ConfirmModal = (props: Props) => {
  const {
    show,
    slippage,
    currentStakeToken,
    stakeAmount,
    gasStore,
    aprPerDay,
    stakeLpInfo,
    buttonIsLoading,
    confirmButtonText,
    beginStake,
    onClose,
  } = props;
  const fm = useFm();
  const { poolInfo } = usePoolInfoContext();

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: 'StakingWeb_bbSOLPagestake_detail',
    });
  }, []);

  return (
    <>
      <Modal
        open={show}
        width={480}
        footer={null}
        title={fm('please_confirm')}
        onClose={() => {
          scTrack(Event.Web3UserClick, {
            page_name: 'StakingWeb_bbSOLPagestake_detail',
            button_name: 'stake_detail_return',
          });
          onClose();
        }}
      >
        <div className={styles.content}>
          <StakingContent
            currentStakeToken={currentStakeToken}
            stakeAmount={stakeAmount}
            stakeLpInfo={stakeLpInfo}
          />
        </div>
        <Row
          label={fm('estimate_daily_profit')}
          value={`${formatUSDYield(aprPerDay, 6)}`}
        />
        <SlippageLostRow
          show={!!slippage}
          className="mt-3"
          slippage={slippage}
          isWarn={poolInfo.isHaveSwap}
        />
        {/* 矿工费 */}
        <GasCircleRow
          className={styles.circleRow}
          show={!!stakeAmount && gasStore.hasGasFee}
          gasStore={gasStore}
          showArrow={false}
        />
        <Button
          loading={buttonIsLoading}
          onClick={() => {
            scTrack(Event.Web3UserClick, {
              page_name: 'StakingWeb_bbSOLPagestake_detail',
              button_name: 'stake_detail_confirm',
            });
            beginStake();
          }}
          variant="primary"
          className={styles.button}
        >
          {confirmButtonText}
        </Button>
      </Modal>
    </>
  );
};
